import { useSelector } from "react-redux";
import { IApplicationState } from "../../store/state";
import { IAuthenticationState } from "../../store/reducers/authentication";

export const useAuthentication = (): [IAuthenticationState] => {
    const authentication = useSelector<IApplicationState, IAuthenticationState>(state => state.authentication);

    return [authentication];
};
